import styled from 'styled-components';

export const SkeletonWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const SkeletonCover = styled.div`
  width: 100%;
  height: 300px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (max-width: 1100px) {
    height: 200px;
  }
`;

export const SkeletonTop = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 20px 40px 35px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-radius: 0 0 40px 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 15px 40px 35px;
    border-radius: 0 0 21px 21px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 15px;
  }
`;

export const SkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

export const SkeletonLeft = styled.div`
  display: flex;
  flex: 1;
  gap: 20px;
  position: relative;
  padding-left: 150px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: relative;
    padding-left: 0;
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const SkeletonAvatar = styled.div`
  position: absolute;
  top: -50px;
  left: 0;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border: 1px solid ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: relative;
    bottom: 30px;
    top: auto;
    left: 0;
    width: 80px;
    height: 80px;
  }
`;

export const SkeletonTextGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    > div:nth-child(3) {
      position: absolute;
      bottom: -10px;
      left: 0;
    }
  }
`;

export const SkeletonRightButton = styled.div`
  width: 220px;
  height: 48px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const SkeletonPromoBlock = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SkeletonLine = styled.div<{ $width?: string; $height?: string }>`
  height: ${({ $height }) => $height || '18px'};
  width: ${({ $width }) => $width || '100%'};
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 4px;

  ${({ $width }) =>
    $width === '50%' &&
    `
    @media (max-width: 949px) {
      width: 70%;
    }

    @media (max-width: 600px) {
      width: 100%;
    }
  `}
`;

export const SkeletonGallery = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 24px;
  overflow: hidden;
  padding: 0;

  div {
    width: 168px;
    height: 105px;
    background-color: ${({ theme }) => theme.palette.secondary.background};
    border-radius: 14px;
    flex-shrink: 0;
  }
`;

export const SkeletonBottom = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 15px;
    border-radius: 21px 21px 0 0;
  }
`;

export const SkeletonLineGroup = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 25px;

  div {
    border-radius: 100px;
    flex-shrink: 0;
    width: 150px;
  }
`;

export const SkeletonCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media (min-width: 480px) and (max-width: 630px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 631px) and (max-width: 785px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 786px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 20px;
  }

  div {
    height: 220px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;
